export default function removeIdAndTypeFromAddress(address = {}) {
  // eslint-disable-next-line no-unused-vars
  const { id, type, organization_id, profile_id, ...obj } = address;
  return obj;
}
